import axios from 'axios';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css'; 

import NotificationsEditor from './NotificationsEditor';
import NotificationsViewer from './NotificationsViewer';
import { ApiRequest } from 'GlobalFunctions';

export default function NotificationsList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => {
    setLoading(false);
  }, []);
  
  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  const [openViewer, setOpenViewer] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  /*=============================================
  LOAD LIST
  =============================================*/
  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/notifications/list",
      method: "get",
      headers: {
        "ltkn": localStorage.getItem('ltkn')
      },
      query: {
        page: page
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      }
    })

    // localStorage.setItem('notificationsPage', page.toString());
  };

  /*=============================================
  HANDLE DELETE
  =============================================*/
  const handleDelete = (notification_id: number) => {
    setActiveItem(notification_id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    const body = {
      notification_id: activeItem
    };

    axios.post(ProjectConfig.api_url + "/notifications/deleteItem", body)
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar('Mensaje eliminado con éxito', { variant: 'success' });
          loadList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenAlert(false);
      });
  };

  return (
    <div id='NotificationsList' className='ModuleContainer'>
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Notificaciones</h2>
            <span className="h2_subtitle">Lista de notificaciones</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null);
                setOpenEditor(true);
              }}
              startIcon={<AddIcon />}
            >
              Nuevo mensaje
            </Button>
          </div>
        </div>

        <Box id='NotificationsListIn' className='box100'>
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>ID de mensaje</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Asunto</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Fecha</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Hora</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.company_notification_id}</TableCell>
                    <TableCell>{item.title}</TableCell>
                    <TableCell>
                      {new Date(item.created_at).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                      })}
                    </TableCell>
                    <TableCell>
                      {new Date(item.created_at).toLocaleTimeString('es-ES', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveItem(item.notification_id);
                          setOpenViewer(true);
                        }}
                      >
                        Ver
                      </Button>
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.notification_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar este mensaje?"
        send={deleteItem}
      />

      <NotificationsEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        loadList={loadList}
      />

      <NotificationsViewer
        setLoading={setLoading}
        open={openViewer}
        setOpen={setOpenViewer}
        notification_id={activeItem}
      />
    </div>
  );
};
